const setTheme = (el, value) => el.setAttribute("data-bs-theme", value);
const vBColorMode = {
  mounted(el, binding) {
    setTheme(el, binding.value);
  },
  updated(el, binding) {
    setTheme(el, binding.value);
  }
};
export {
  vBColorMode
};
//# sourceMappingURL=index.mjs.map
